module.exports = __webpack_public_path__ + "assets/img/mecha-87edf6a3.png";